import videojs from "video.js";

/**
 * Ecomott用のvideo.jsにBasic認証ヘッダーを追加する
 */
export function setEcomottAuthHeader(cameraList) {
  if (videojs && videojs.Vhs && videojs.Vhs.xhr) {
    videojs.Vhs.xhr.beforeRequest = function(options) {
      const uri = options.uri || "";
      const matched = cameraList.find(
        cam => uri.indexOf(`${cam.device_address}/${cam.hash}`) === 0
      );

      // Basic認証設定
      if (matched) {
        const username = matched.onvifUserName || "";
        const password = matched.onvifPassword || "";
        options.headers = options.headers || {};
        options.headers["Authorization"] =
          "Basic " + btoa(username + ":" + password);
      }

      return options;
    };
  }
}

/**
 * Ecomottのカメラ再生を開始する
 */
export function playEcomottVideo(player, camera) {
  if (!player || !camera) return;

  const src = `${camera.device_address}/${camera.hash}/index.m3u8`;
  const video = {
    withCredentials: false,
    type: "application/x-mpegurl",
    src: src,
  };
  player.src(video);
}
